import React from 'react';
import { ManagmentSVG } from '../../../components';
import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../styles/theme';

export default function ClientDropHeader () {
    const { t } = useTranslation();
    return (
        <Box className='dropHeader'>
            <Box className='svgIcon'>
                <ManagmentSVG customStroke={palette.secondary[600]}/>
            </Box>
            <Typography variant='pageHeaderTitle' className='headerText'>{t('management.title')}</Typography>
        </Box>
    );
}
